import React from 'react'
import { TurnPanelConceptGallery } from './turn-panel-concepts'

export default function ThirdRoundGallery() {
  return <TurnPanelConceptGallery round={3} />
}
